import { ShareUTMOptions } from '@eventbrite/event-renderer';

export const defaultUtmOptions: ShareUTMOptions = {
    'utm-campaign': 'social',
    'utm-content': 'attendeeshare',
    'utm-medium': 'discovery',
    'utm-term': '',
};
